import React, { useState } from 'react';
import { useOnboardProvider } from '../../../../../providers/onboard-provider';
import LoadingButton from '../../../../../components/LoadingButton';
import CompleteButton from '../../../../../components/CompleteButton';
import { TxState, UserLpDeposit } from '../../../../../web3/types';
import { claim } from '../../../../../web3/LpDepositor/claim';
import BigNumber from 'bignumber.js';
import {  maxUint256 } from '../../../../../web3/utils';
import TxModal from '../../../../../components/TxModal';
import { Typography } from '@mui/material';

type Props = {
    earning: UserLpDeposit;
    withBonus: boolean;
}

export default function ClaimPoolRewards({ earning, withBonus }: Props) {
    const { signer, account } = useOnboardProvider();

    const [txState, setTxState] = useState<TxState>('none');
    const [currentTxHash, setCurrentTxHash] = useState('');

    const handleClaimPoolRewards = async () => {
        if (signer !== undefined && account !== undefined && account !== null && earning.token.length > 0) {
            const claimMaxAmount = new BigNumber(maxUint256().toString());

            const txFinished = () => {
                setTxState('finished');
            }

            await claim(
                {
                    setTxHash: setCurrentTxHash,
                    setTxState: setTxState,
                    setTxError: () => {},
                    txFinished: txFinished,
                },
                signer,
                account,
                [earning.token],
                withBonus ? claimMaxAmount : new BigNumber(0)
            );
        }
    }

    return (<>
       {txState === 'none' || txState === 'pending' || txState === 'confirm' ? <LoadingButton
            content={`Claim DDD & EPX`}
            variant={"blue"}
            onClick={() => handleClaimPoolRewards()}
            disabled={earning.totalBaseClaimableUSD === 0 || txState === 'pending' ? true : false}
            loading={txState === 'pending' ? true : false }
        /> : <CompleteButton content={`Claimed`} />}
        {withBonus ?
            <Typography sx={{
                    paddingTop: '4px',
                    fontSize: '12px',
                    fontWeight: 400,
                    lineHeight: '140%',
                    color: '#1A2037'
                }}>You'll claim with the 3x bonus</Typography>
            : <></>
        }
        <TxModal txState={txState} currentTxHash={currentTxHash} setTxState={setTxState} />
    </>)
}